import styled from '@emotion/styled';
import { borderRadii } from 'app/spacing';
import { css } from '@emotion/core';

export default styled.div`
  position: relative;
  overflow: hidden;
  ${({ focused }) =>
    focused &&
    css`
      border-color: var(--color-button-secondary-hover) !important;
    `}
  ${({ addBorder }) =>
    addBorder &&
    css`
      border-radius: ${borderRadii.small};
      border: 1px solid var(--color-border-medium);
    `};
  ${({ disabled }) =>
    disabled
      ? css`
          background-color: var(--color-background-light);

          &:hover {
            border-color: var(--color-border-medium);
          }
        `
      : css``}

  ${({ enableResize, minHeight, minWidth = 230 }) =>
    enableResize &&
    css`
      height: ${minHeight ||
      30}px; // arbitury value that looks right to stop the resize going to small
      min-height: ${minHeight ||
      30}px; // arbitury value that looks right to stop the resize going to small
      resize: both;
      overflow: hidden;

      max-width: 100%;
      ${minWidth &&
      css`
        min-width: ${minWidth}px;
      `}
    `}

  ${({ fullHeight }) =>
    fullHeight &&
    css`
      height: 100%;
    `};
  ${({ error }) =>
    error &&
    css`
      &&,
      &&:hover {
        border-radius: ${borderRadii.small};
        border: 1px solid var(--color-button-warning-hover);
      }
    `}
`;
